<p-toast position="bottom-center" [key]="CLIENT_ERROR_TOAST_KEY">
    <ng-template #message let-message>
        <span class="p-toast-message-icon">
            <i
                class="pi pi-times-circle"
                style="color: #b71c1c; font-size: 2rem"></i>
        </span>
        <div class="p-toast-message-text">
            <div class="p-toast-summary">{{ message.summary }}</div>

            <div class="p-toast-detail">
                {{ message.detail }}&nbsp;<p-button
                    [link]="true"
                    (onClick)="copyEmailAddressToClipboard(tooltipCopied)">
                    <span pButtonLabel>{{ SUPPORT_CONTACT_EMAIL }}</span>
                    <span pButtonIcon [class]="currentCopyButtonIcon"></span>
                </p-button>
                <mat-tooltip
                    #tooltipCopied="matTooltip"
                    matTooltip="{{ 'shared.error.copyButton' | translate }}"
                    matTooltipPosition="right"
                    matTooltipClass="matTooltip"
                    style="z-index: 10">
                </mat-tooltip>
            </div>
        </div>
    </ng-template>
</p-toast>
